import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"

export function useGetAllowedAuthenticationFactors() {
  return useSuspenseQueryGet(
    "/api/UserAuthenticationFactor/GetAuthenticationFactorTypes",
    null
  )
}
